import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>
          Поясная сумка — удобный и модный аксессуар, который пригодится вам на прогулке: 
          в ней поместится самое необходимое, а руки останутся свободными. 
          Длина ремня регулируется, ремень застегивается на надёжную застёжку-карабин.
        </p>
        <p>Состав: 100% полиэстер</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
